import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { useConfig } from "./config-context.js";
const UniqueFieldSuffixContext = createContext(
  void 0
);
const UniqueFieldSuffixContextProvider = ({
  parentId = "id",
  children
}) => {
  const { compId = "comp" } = useConfig();
  const uniqueId = `${compId}-${parentId.split("-").at(0)}`;
  return /* @__PURE__ */ jsx(UniqueFieldSuffixContext.Provider, { value: uniqueId, children });
};
function useUniqueFieldSuffix() {
  const context = useContext(UniqueFieldSuffixContext);
  if (context === void 0) {
    throw new Error(
      "useUniqueFieldSuffix must be used within a UniqueFieldSuffixContextProvider"
    );
  }
  return context;
}
export {
  UniqueFieldSuffixContext,
  UniqueFieldSuffixContextProvider,
  useUniqueFieldSuffix
};
//# sourceMappingURL=unique-field-suffix-context.js.map
